export default "__VITE_ASSET__BAIE8ee3__"